import React, { useState, useEffect } from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';
import axios from 'axios';

const MarketTrendWidget = ({ categoryId, nodeId }) => {
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!categoryId || !nodeId) return;

    const loadMarketTrends = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/api/learning/nodes/${categoryId}/${nodeId}/market-trends`
        );
        if (response.data.success) setAnalysis(response.data.analysis);
      } catch (error) {
        console.error('Error loading market trends:', error);
      } finally {
        setLoading(false);
      }
    };

    loadMarketTrends();
  }, [categoryId, nodeId]);

  if (loading) {
    return (
      <div className="aura-card border-t-2 border-t-pine light-surface p-4 mb-6">
        <p className="text-label text-secondary flex items-center gap-2">
          <ChartBarIcon className="w-4 h-4" />
          Connecting to current market context…
        </p>
      </div>
    );
  }

  if (!analysis) return null;

  return (
    <div className="aura-card border-t-2 border-t-pine light-surface p-5 mb-6 max-w-prose mx-auto">
      <button
        type="button"
        className="w-full flex items-center justify-between gap-4 text-left"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
      >
        <div className="flex items-start gap-3">
          <ChartBarIcon className="w-5 h-5 text-pine shrink-0 mt-0.5" />
          <div>
            <h4 className="font-display text-h3 text-primary">Current market context</h4>
            <p className="text-label text-secondary mt-1">
              How this concept applies to today&apos;s markets
            </p>
          </div>
        </div>
        <span className="text-label text-faint">{expanded ? '−' : '+'}</span>
      </button>

      {expanded && (
        <div className="mt-4 pt-4 border-t border-hairline space-y-4">
          {analysis.market_context && (
            <div>
              <h5 className="text-label font-medium text-primary mb-2">Market context</h5>
              <p className="text-body text-secondary">{analysis.market_context}</p>
            </div>
          )}
          {analysis.connection && (
            <div>
              <h5 className="text-label font-medium text-primary mb-2">Connection to trends</h5>
              <p className="text-body text-secondary">{analysis.connection}</p>
            </div>
          )}
          {analysis.practical_application && (
            <div>
              <h5 className="text-label font-medium text-primary mb-2">Practical application</h5>
              <p className="text-body text-secondary">{analysis.practical_application}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MarketTrendWidget;
